/// <reference path="../../../typings/index.d.ts" />
///<reference path="../components/short-cuts/index.d.ts"/>

module Meevo {
    'use strict';

    import ShortCutGroup = Meevo.Components.ShortCuts.ShortCutGroup;
    import GroupLevels = Meevo.Components.ShortCuts.GroupLevels;
    import IShortCutGroup = Meevo.Components.ShortCuts.IShortCutGroup;

    interface IMainScope {

        scope: ng.IScope;

        /**
         * The main set of states coming from the state service
         *
         * @default null
         */
        states: Array<ng.ui.IState>;

        /**
         * The main collection of available contexts
         *
         * @default []
         */
        contexts: Array<IContext>;

        /**
         * The collection of currently open sticky contexts
         *
         * @default []
         */
        stickyContexts: Array<IContext>;

        modalPromise: angular.IPromise<boolean>;

        openMenu(): void;
        openSecondMenu(state: any): void;
        toggleLeft(): void;
        isAuthenticated: boolean;
        callCenterSafeContexts: Array<string>;
        globalShortCutGroup: ShortCutGroup;
        searchMenuShortCutsGroup: IShortCutGroup;

    }

    class MainCtrl implements IMainScope {
        state: ng.ui.IStateService;
        modal: angular.material.IDialogService;
        modalPromise: angular.IPromise<boolean>;
        states: Array<ng.ui.IState>;
        contexts: Array<IContext> = [];
        stickyContexts: Array<IContext> = [];
        scope: ng.IScope;
        rootScope: ng.IRootScopeService;
        sideContextMenu: Meevo.IMeevoSideMenu;
        filter: angular.IFilterService;
        mdUtil: any;
        toggleLeft: any;
        isAuthenticated: boolean;
        callCenterSafeContexts: Array<string>;
        subMenuItems: any[];
        isOpen: boolean;
        blur: boolean;
        lock: boolean;
        currentMenuItem: Object;
        globalShortCutGroup: ShortCutGroup;
        userName: string;
        locationName: string;
        pendingParameters: IParameterMetadata;
        searchMenuShortCutsGroup: IShortCutGroup;
        isAuthProviderJCP: boolean;
        sessionKeepAliveContexts: string[];

        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected securityParts = Meevo.Components.Common.SecurityParts;
        protected securityKeysSections: Array<Meevo.Model.SecurityItem>;

        static $inject = [
            "$scope",
            "$state",
            "$mdDialog",
            "$rootScope",
            "$mdSidenav",
            "$mdUtil",
            "meevo.components.modal.ModalService",
            "$window",
            "$mdComponentRegistry",
            "meevo.ContextParams",
            "meevo.components.tracking.TrackingService",
            "meevo.components.common.DataService",
            "$timeout",
            "meevo.AppSettings",
            "meevo.components.common.IdentityService",
            "meevo.components.common.SecurityService",
            "meevo.menuService",
            "meevo.components.common.BusinessInfoDataService",
            "meevo.components.short-cuts.ShortCutsService",
            "meevo.components.common.meevoPushMessageHandler",
            "$filter",
            "$q",
            "$cookies"
        ];

        constructor(
            $scope: ng.IScope,
            $state: ng.ui.IStateService,
            $mdDialog: angular.material.IDialogService,
            $rootScope: ng.IRootScopeService,
            $mdSidenav: ng.material.ISidenavService,
            $mdUtil: any,
            private modalService: Meevo.Components.Modal.IModalService,
            private $window: any,
            private $mdComponentRegistry: any,
            private contextParams: Meevo.ContextParamsService,
            private meevoTracker: Meevo.Components.Tracking.ITrackingService,
            private dataService: Meevo.Components.Common.ICommonDataService,
            private $timeout: angular.ITimeoutService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            private identityService: Meevo.Components.Common.IIdentityService,
            private securityService: Meevo.Components.Common.ISecurityService,
            private menuService: Meevo.MenuService,
            private businessInfoDataService: Meevo.Components.Common.IBusinessInfoDataService,
            private shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            private pushMessageHandler: any,
            private $filter: angular.IFilterService,
            public $q: ng.IQService,
            $cookies: angular.cookies.ICookiesService
        ) {

            var controller = this;
            const routes = this.appSettings.ROUTE_NAMES;
            /*  Opt-In Context To Keep Session Alive   */
            this.sessionKeepAliveContexts = [
                routes.selfCheckInKiosk, routes.walkinManagerKiosk, routes.walkinManagerDisplay, routes.docsAndFormsKiosk
            ];

            this.searchMenuShortCutsGroup = new ShortCutGroup([], { deactivateGlobal: true, groupLevel: GroupLevels.Menu });
            // store the state service
            controller.state = $state;
            controller.isOpen = false;
            controller.isAuthenticated = false;
            controller.callCenterSafeContexts = ['home', 'bookingAgent'];

            this.appSettings.SECURITY_ACCESS_KEYS = this.dataService.customMethodData("api/Security/Check", 'POST', { keys: "%" }).then((response) => {
                return response.data;
            });

            // store the modal service
            controller.modal = $mdDialog;
            //var buildToggler = (navID) => {
            //  var debounceFn = $mdUtil.debounce(function () {
            //    controller.sideContextMenu(navID)
            //      .toggle()
            //      .then(function () {
            //        //console.debug("toggle " + navID + " is done");
            //      });
            //  }, 200);
            //  return debounceFn;
            //}
            //MD sidenav service
            //controller.toggleLeft = buildToggler('left');


            controller.sideContextMenu = $mdSidenav;
            // store the main set of states coming from the state service
            controller.states = $state.get();

            controller.scope = $scope;

            controller.rootScope = $rootScope;
            controller.filter = $filter;

            controller.scope.$on(Meevo.Components.Common.Messages.OPEN_MENU, () => {
                this.openMenu();
            });

            controller.scope.$on(Meevo.Components.Common.Messages.AUTO_LOGOUT_USER, (event, data) => {
                if (data) {
                    const logOutData = JSON.parse(data);
                    if (this.identityService.current().userId == logOutData.userId && this.identityService.current().locationId == logOutData.logOutLocationId) {
                        {
                            sessionTimeoutHandler(Meevo.Model.SessionState.LogOut);
                        }
                    }
                }
            });

            /**
             * Message listener to handle when a menu item is selected. The menu
             * is currently simply the list of states (routes) registered with the app.
             * When one is selected we receive the state here, navigate to the state,
             * and close the menu if is open.
             */
            controller.scope.$on(Meevo.Components.Common.Messages.MENU_ITEM_SELECTED,
                (event: angular.IAngularEvent, stateName: string, stateParams: any = null) => {
                    const contextItem = <IContext>this.state.get(stateName);

                    const shortDescripion: string = controller.getShortDescription(
                        Meevo.Model.NounEnum.MeevoMenu,
                        Meevo.Model.VerbEnum.Feature,
                        controller.filter<any>('meevoAutoCapitalization')(contextItem.auditName || contextItem.name)
                    );

                    controller.meevoTracker.saveTrackingInfo(new Meevo.Model.TrackingItem(
                        Meevo.Model.NounEnum.MeevoMenu, Meevo.Model.VerbEnum.Feature,
                        controller.filter<any>('meevoAutoCapitalization')(stateName),
                        null, shortDescripion
                    ));
                    controller.onMenuItemSelected(stateName, stateParams);
                    return function () { };
                });


            /**
             * Message listener to handle checking if a menu item is already opened and returning a boolean. The menu
             * is currently simply the list of states (routes) registered with the app.
             * When one is selected we receive the state here, navigate to the state,
             * and close the menu if is open.
             */
            controller.scope.$on(Meevo.Components.Common.Messages.MENU_ITEM_OPENED,
                (event: angular.IAngularEvent, stateName: Object, params) => {
                    var isMenuItemOpened = _.findWhere(controller.contexts, stateName);
                    var originalThis = params.originalThis;
                    params.isOpenedCallback.call(originalThis, isMenuItemOpened);
                });

            /**
            * Message listener to handle when the UI Router has successfully changed the state.
            * If pendingParameters are present from when the state navigation was requested, we emit an APPLY_PARAMS_TO_CONTEXT message
            * so that the controller of the new state can recieve the new parameters.
            */
            controller.scope.$on(Meevo.Components.Common.Messages.STATE_CHANGE_SUCCESS,
                (event: angular.IAngularEvent, toState: string) => {
                    this.viewChanged(event, toState);
                    if (!_.isEmpty(controller.pendingParameters)) {
                        //controller.rootScope.$emit(Meevo.Components.Common.Messages.APPLY_PARAMS_TO_CONTEXT, controller.pendingParameters.context, controller.pendingParameters.params);
                        controller.broadcastApplyParams(controller.pendingParameters.context,
                            controller.pendingParameters.params);
                        controller.pendingParameters = null;
                    }
                });

            /**
             * Triggered when an authentication success message is received.
             * This will trigger the isAuthenticated bit to true which enables the main content area to be shown.
             */
            controller.scope.$on(Meevo.Components.Common.Messages.AUTHENTICATION_SUCCESS,
                (event: angular.IAngularEvent, args: Meevo.Components.Common.IIdentity) => {
                    controller.isAuthenticated = true;
                    controller.userName = args.userName;
                    controller.locationName = args.locationName;
                    controller.isAuthProviderJCP = this.identityService.isAuthProviderJcp;

                    this.handleCallCenterEmulation(args.effectiveCallCenterId);
                    this.GoToMeevoAcademyCourseURL();
                    return function () { };

                });

            const SECOND = 1 * 1000;                    // 1 second in milliseconds
            const MINUTE = 60 * SECOND;                 // 1 minute in milliseconds
            const TIMEBEFORELOGOUT = 30 * SECOND;
            const INTERVALTIME = 1000;
            var sessionCountdownTime: any;
            var setSessionTimeout: any = false;
            var sessionTimeoutTime: any;
            var session;
            var sessionTimeStart = Date.now();
            var lastEventTime = Date.now();

            var setEvents = (set: boolean = true) => {
                $(window).off('keypress.autoLogout mousemove.autoLogout touchstart.autoLogout mousewheel.autoLogout mouseup.autoLogout');
                if (set) {
                    $(window).on('keypress.autoLogout mousemove.autoLogout touchstart.autoLogout mousewheel.autoLogout mouseup.autoLogout', () => {
                        lastEventTime = Date.now();
                    });
                    console.debug('autoLogout: Events On');
                } else {
                    console.debug('autoLogout: Events Off');
                }
            }

            controller.scope.$on(Meevo.Components.Common.Messages.REFRESH_LOCKOUT_LAST_EVENT_TIME, (event: angular.IAngularEvent) => {
                lastEventTime = Date.now();
            })

            controller.scope.$on(Meevo.Components.Common.Messages.SESSION_COUNTDOWN, (event: angular.IAngularEvent) => {
                lastEventTime = Date.now();
                sessionTimeStart = Date.now();
                /* Initialize AutoLogout And Lockout */
                session = this.identityService.current();
                sessionTimeoutTime = session.sessionTimeoutMinutes * MINUTE
                sessionCountdownTime = this.identityService.isAuthProviderJcp ? sessionTimeoutTime - SECOND : sessionTimeoutTime - TIMEBEFORELOGOUT
                iniInterval();
                setEvents();
            })

            controller.scope.$on(Meevo.Components.Common.Messages.CLEAR_SESSION_TIMEOUT, (event: angular.IAngularEvent) => {
                setEvents(false);
                clearInterval(setSessionTimeout);
            });

            var sessionKeepAliveInterval;
            const iniSessionKeepAlive = (sessionRefreshIntervalTime) => {
                sessionKeepAliveInterval = setInterval(() => {
                    console.log('KEEP_SESSION_ALIVE');
                    $rootScope.$broadcast(Meevo.Components.Common.Messages.REFRESH_IDENTITY, false);
                }, sessionRefreshIntervalTime);
            }
            controller.scope.$on(Meevo.Components.Common.Messages.KEEP_SESSION_ALIVE, (event: angular.IAngularEvent) => {
                const sessionRefreshIntervalTime = (+this.identityService.current().sessionTimeoutMinutes * MINUTE) - TIMEBEFORELOGOUT;
                setEvents(false);
                clearInterval(setSessionTimeout);
                if (sessionKeepAliveInterval) {
                    clearInterval(sessionKeepAliveInterval);
                }
                iniSessionKeepAlive(sessionRefreshIntervalTime);
            });

            controller.scope.$on(Meevo.Components.Common.Messages.SESSION_TIMEOUT_HANDLER, (event: angular.IAngularEvent, sessionState: Meevo.Model.SessionState, caller?: string) => {
                sessionTimeoutHandler(sessionState, caller)
            })

            controller.scope.$on(Meevo.Components.Common.Messages.RESTART_SESSION_COUNTDOWN, (event: ng.IAngularEvent) => {
                setEvents(false);
                clearInterval(setSessionTimeout);
                clearInterval(sessionKeepAliveInterval);
                $rootScope.$broadcast(Meevo.Components.Common.Messages.REFRESH_IDENTITY, true)
            });


            var sessionTimeoutHandler = (state: Meevo.Model.SessionState, caller?: string) => {
                let options: Meevo.Components.Modal.IModalOptions = {
                    clickOutsideToClose: false,
                    templateUrl: "app/components/lockout/lockout.html",
                    controller: "meevo.lockout.LockoutController",
                    controllerAs: "lockout",
                    bindToController: true,
                    locals: { caller: caller }
                }

                if (state === Meevo.Model.SessionState.LogOut || state === Meevo.Model.SessionState.Lockout) {
                    this.dataService.logout().then(() => {
                        if (identityService.isEmulating) {
                            this.$window.localStorage.removeItem(Components.Common.Constants.CALL_CENTER_EMULATION_STORAGE);
                        }
                        if (state === Meevo.Model.SessionState.Lockout) {
                            this.lock = true;
                            var logoutUser = this.identityService.current().displayName;
                            this.modalService.showCustom(options).then((redirect) => {
                                this.lock = false
                                var loginUser = this.identityService.current().displayName;
                                var isProfileSettingsOpen = _.findWhere(this.contexts, { name: this.appSettings.ROUTE_NAMES.profileSettings });
                                var isAppointmentBookOpen = _.findWhere(this.contexts, { name: this.appSettings.ROUTE_NAMES.appointmentBook });
                                if (logoutUser !== loginUser) {
                                    if (isProfileSettingsOpen) {
                                        isProfileSettingsOpen.close();
                                    }
                                    if (isAppointmentBookOpen) {
                                        isAppointmentBookOpen.close();
                                    }
                                }
                                if (!redirect && !this.identityService.isEmulating) {
                                    /*  Passing 'timeStamp' Dummy Param To Force Reload */
                                    doReload();
                                }
                            });
                        } else {
                            $cookies.remove(Meevo.Components.Common.REMOVE_THIS_COOKIE_AND_DO_LOGOUT_KEY);
                            this.$window.onbeforeunload = () => null;
                            this.$window.location.assign(this.identityService.current().sessionTimeoutRedirectUrl);
                        }
                    })
                } else {
                    $rootScope.$broadcast(Meevo.Components.Common.Messages.RESTART_SESSION_COUNTDOWN);
                }
            }

            (<any>window).lockout = sessionTimeoutHandler;

            var doReload = () => {
                this.state.go(this.appSettings.ROUTE_NAMES.home, { 'timeStamp': Date.now() }, { reload: true });
                this.appSettings.SECURITY_ACCESS_KEYS = (<any>this.securityService.refreshSecurityKeys(true)).then((res) => {
                    $rootScope.$broadcast(Meevo.Components.Common.Messages.REFRESH_SECURITY_KEYS)
                    return res.data
                });
            }

            controller.scope.$on(Meevo.Components.Common.Messages.FORCE_SESSION_RELOAD, (event: ng.IAngularEvent) => {
                doReload();
            });

            var iniInterval = () => {
                clearInterval(setSessionTimeout);
                setSessionTimeout = setInterval(checkSessionTimeout, INTERVALTIME);
            }

            var checkSessionTimeout = () => {
                const userSettings = appSettings.APP_BUSINFOSETTINGS.usersSettings;
                if (!userSettings || !userSettings.enableAutomaticLockout) {
                    return;
                }

                let now = Date.now();
                let timeSinceLastEvent = now - lastEventTime;
                let isTimeToLogout = timeSinceLastEvent >= sessionCountdownTime
                let sessionElapsedTime = now - sessionTimeStart;
                /**
                 *  sessionStillAlive: If sessionElapsedTime Is 3 Secs Before Session Expires
                 *  canRefreshSession: Only When SessionElapsedTime Is 10 Sec Before Session Expires
                 */
                let sessionStillAlive = (sessionElapsedTime + (3 * SECOND)) < sessionTimeoutTime
                let canRefreshSession = (sessionElapsedTime + (10 * SECOND)) > sessionTimeoutTime
                /*  console.log(`sessionElapsedTime: ${sessionElapsedTime / SECOND} - timeSinceLastEvent: ${timeSinceLastEvent / SECOND}`);   */
                if (sessionStillAlive && canRefreshSession) {
                    console.log('sessionStillAlive and canRefreshSession');
                    sessionTimeStart = Date.now();
                    this.rootScope.$broadcast(Meevo.Components.Common.Messages.REFRESH_IDENTITY)
                }

                if (isTimeToLogout) {
                    setEvents(false)
                    clearInterval(setSessionTimeout)

                    let timeToLogout = sessionTimeoutTime - timeSinceLastEvent;
                    let timeLeft = Math.ceil(timeToLogout / SECOND)
                    let iniSessionTimeout = sessionStillAlive && (timeLeft > 0)
                    timeLeft = iniSessionTimeout ? timeLeft : 0

                    if (iniSessionTimeout) {
                        console.log(`sessionElapsedTime: ${sessionElapsedTime / SECOND} - timeLeft: ${timeLeft}`);
                        this.rootScope.$broadcast(Meevo.Components.Common.Messages.REFRESH_IDENTITY);
                    }
                    /*  So TimeDisplay Does Not Return UnAuthorized */
                    this.identityService.current().isAuthenticated = false;

                    /*  If Another Dialog Is Open Closed it. Otherwise sessionTimeout Will Not Show (Safari)*/
                    let isDialogOpen = angular.element('body').hasClass('md-dialog-is-showing');
                    // if (isDialogOpen)
                    // controller.modal.hide()

                    let modal = {
                        clickOutsideToClose: false,
                        templateUrl: "app/components/sessionTimeout/sessionTimeout.html",
                        controller: "meevo.sessionTimeout.SessionTimeoutController",
                        controllerAs: "sessionTimeoutCtrl",
                        bindToController: true,
                        locals: { session: session, timeLeft: timeLeft, modalShowTime: Date.now() }
                    }

                    if (controller.isAuthProviderJCP) {
                        sessionTimeoutHandler(Model.SessionState.LogOut, 'SessionTimeoutController')
                    } else {
                        controller.modalService.showCustom(modal).then((state: Meevo.Model.SessionState) => {
                            sessionTimeoutHandler(state, 'SessionTimeoutController')
                        })
                    }
                }

            };

            /*
             *  TODO:  Check If MaintenanceForm Is $dirty  - Disabled
             */
            this.$window.onbeforeunload = (event) => {
                let referrer = document.referrer;
                if (Model.Guard.isSomething(referrer))
                    this.$window.history.pushState('logoutUrl', null, referrer);
                else if (Model.Guard.isSomething(session))
                    this.$window.history.pushState('logoutUrl', null, session.logoutUrl);
                else {
                    var url = document.URL;
                    var tenantId = url.split('tenantId=')[1];
                    tenantId = decodeURIComponent(tenantId);
                    this.$window.history.pushState('logoutUrl', null, url);
                }
            }

            controller.scope.$on(Meevo.Components.Common.Messages.GOTO_STATE,
                (event: angular.IAngularEvent, routeInfo: any) => {
                    var state = <IContext>_.findWhere(controller.states, { name: routeInfo.stateName });
                    var context = _.findWhere(controller.contexts, { name: routeInfo.stateName });
                    const isNotNavigate = routeInfo.stateParams && routeInfo.stateParams.isNotNavigateToSate;

                    if (_.isNumber(routeInfo.clientAlertType)) {
                        routeInfo.stateParams.clientAlertType = routeInfo.clientAlertType;
                    }

                    let continueGotoState = () => {
                        if (state != null && context != null && state.navigate) {
                            if (routeInfo.stateParams) {
                                // override the previous params
                                context.params = routeInfo.stateParams;
                            }

                            if (!isNotNavigate) state.navigate();
                        } else {
                            var isInteropContext = state.views && state.views[routeInfo.stateName].controllerAs === "interop";
                            routeInfo.stateParams = isInteropContext ? { ...routeInfo.stateParams, interopParams: { isInterop: true, targetRoute: routeInfo.stateName } } : routeInfo.stateParams;
                            this.addContext(state.name, routeInfo.stateParams, false);
                        }

                        /**
                            Fixed view'issue with adding a new tab without going to it
                            It is intended for Meevo Messenger plugin. Showed it in navbar and updated badge
                        */
                        if (isNotNavigate) this.scope.$apply();

                        this.broadcastApplyParams(state, routeInfo.stateParams);
                    };

                    if (routeInfo.securityKey) {
                        this.securityService.checkSecurityItem(routeInfo.securityKey).then((securityItem) => {
                            if (securityItem && securityItem.securityAccess !== Meevo.Model.SecurityAccessEnum.Grant) {
                                this.securityService.showDenyWarning(securityItem.securityKeyPath, routeInfo.securityKey);
                                return;
                            }

                            continueGotoState();
                        });
                    } else {
                        continueGotoState();
                    }

                    return function () { };
                });

            controller.scope.$on(Meevo.Components.Common.Messages.CLOSE_CONTEXT,
                (event: angular.IAngularEvent, state: IContext, targetStateName: string, createContext: boolean = false) => {
                    this.removeContext(state, targetStateName, createContext);
                    return function () { };
                });
            controller.scope.$on(Meevo.Components.Common.Messages.CLOSE_REMOTE_CONTEXTS,
                (event: angular.IAngularEvent) => {

                    const contextsToClose = this.contexts.filter(context => !this.callCenterSafeContexts.find(ccSafe => ccSafe === context.name));
                    contextsToClose.forEach(context => this.removeContext(context));
                });

            /**
             * Message listener to handle when a menu item is selected via the convo bar.
             */
            controller.scope.$on(Meevo.Components.Common.Messages.MENU_ITEM_SELECTED_VIA_CONVO,
                (event: angular.IAngularEvent, stateName: string, params: any = null) => {
                    const contextItem = <IContext>this.state.get(stateName);

                    const shortDescripion: string = this.getShortDescription(
                        Meevo.Model.NounEnum.Convobar,
                        Meevo.Model.VerbEnum.Feature,
                        controller.filter<any>('meevoAutoCapitalization')(stateName)
                    );

                    controller.meevoTracker.saveTrackingInfo(new Meevo.Model.TrackingItem(
                        Meevo.Model.NounEnum.Convobar,
                        Meevo.Model.VerbEnum.Feature,
                        controller.filter<any>('meevoAutoCapitalization')(contextItem.auditName || contextItem.name),
                        null,
                        shortDescripion
                    ));
                    controller.onMenuItemSelected(stateName, params, true);
                });

            /**
             * Message listener to handle when the menu is requesting a close.
             * Handled here because this controller currently owns the modal for
             * the menu.
             */
            controller.scope.$on(Meevo.Components.Common.Messages.CLOSE_MENU,
                (event: angular.IAngularEvent) => {
                    controller.onCloseMenu();
                });


            controller.scope.$on(Meevo.Components.Common.Messages.CLOSE_SEARCH_MENU,
                (event: angular.IAngularEvent) => {
                    controller.onSearchCloseMenu();
                });

            controller.scope.$on(Meevo.Components.Common.Messages.OPEN_SEARCH_MENU,
                (event: angular.IAngularEvent) => {
                    controller.onOpenSearchMenu();
                });

            controller.scope.$on(Meevo.Components.Common.Messages.CLOSE_AICHAT,
                (event: angular.IAngularEvent) => {
                    controller.onCloseAiChat();
                });

            controller.scope.$on(Meevo.Components.Common.Messages.OPEN_AICHAT,
                (event: angular.IAngularEvent) => {
                    controller.onOpenAiChat();
                });

            controller.scope.$on(Meevo.Components.Common.Messages.MINIMIZE_AICHAT,
                (event: angular.IAngularEvent) => {
                    controller.aiChatMinimized = true;
                    controller.onCloseAiChat();
                });

            /**
            *
            */
            controller.rootScope.$on(Meevo.Components.Common.Messages.SERVER_VALIDATION,
                (event: angular.IAngularEvent,
                    message: string,
                    notificationMode: Meevo.Model.NotificationModeType,
                    translationRequired: boolean = false,
                    promptAsError: boolean = false) => {
                    if (notificationMode === Meevo.Model.NotificationModeType.Modal) {
                        // Showing the alert with the translationMode set to DoNotTranslate since we want to pass through the text
                        // from the server. TODO: Review how we want to handle i18n on server validation messages. The server should
                        // really pass back a contentKey in addition to the default English message.
                        let translationMode = translationRequired
                            ? Components.Modal.ModalTranslationModes.Translate
                            : Components.Modal.ModalTranslationModes.DoNotTranslate;

                        if (promptAsError)
                            controller.modalService.error(message, translationMode, true).then(() => {
                                controller.rootScope.$broadcast(Meevo.Components.Common.Messages.SERVER_VALIDATION_COMPLETE);
                            });
                        else
                            controller.modalService.alert(message, translationMode, true).then(() => {
                                controller.rootScope.$broadcast(Meevo.Components.Common.Messages.SERVER_VALIDATION_COMPLETE);
                            });
                    } else if (notificationMode === Meevo.Model.NotificationModeType.Toast) {
                        // TODO: Implement toast
                    }
                });

            controller.rootScope.$on(Meevo.Components.Common.Messages.ELEVATION_CHALLENGE,
                (event: angular.IAngularEvent, deferred: angular.IDeferred<any>, requestedSecurityKeys: string[], displayName: string, userNameFor: string, securityKeyPath: string) => {


                    let options: Meevo.Components.Modal.IModalOptions = {
                        templateUrl: "app/components/elevation/elevationChallenge.html",
                        locals: {
                            requestedSecurityKeys: requestedSecurityKeys,
                            displayName: displayName,
                            userNameFor: userNameFor,
                            securityKeyPath: securityKeyPath
                        },
                        controller: "meevo.elevation.ElevationChallengeController",
                        controllerAs: "controller",
                        bindToController: true,
                        skipHide: true,
                        multiple: true,
                    };


                    this.modalService.showCustom(options).then((isAuthenticated: boolean) => {
                        if (Model.Guard.isNothing(deferred))
                            return;
                        if (isAuthenticated) {
                            controller.rootScope.$emit(Meevo.Components.Common.Messages.CHECK_SECURITY_KEY_AFTER_ELEVATION, [requestedSecurityKeys, displayName]);
                            return deferred.resolve();
                        }

                        return deferred.reject();
                    }, () => {
                        return deferred.reject();
                    })
                        .catch((ex: any) => {
                            return deferred.reject();
                        });


                });

            this.rootScope.$on(Meevo.Components.Common.Messages.MENU_SHORT_CUT_CLICK,
                (event: angular.IAngularEvent, menuItem: IMenuItem) => {
                    this.openSecondMenu(menuItem);
                });

            this.rootScope.$on(Meevo.Components.Common.Messages.MEEVO_MESSENGER_INBOUND_MESSAGE,
                (event: angular.IAngularEvent, notification: string) => {
                    // Check if we can notify current user
                    const msg: Meevo.Plugins.MeevoMessenger.MeevoMessengerMessage = JSON.parse(notification);

                    const meevoMessengerContext = <IContext>this.state.get(this.appSettings.ROUTE_NAMES.meevoMessenger);
                    const isActive = this.state.includes(meevoMessengerContext.name);

                    // check for the new conversations
                    const newConversations: Meevo.Plugins.MeevoMessenger.MeevoMessengerConversation =
                        meevoMessengerContext.params.newConversations && Object.keys(meevoMessengerContext.params.newConversations).length ? meevoMessengerContext.params.newConversations : {};

                    // Add new inbound message
                    if (msg.isInbound) {
                        // Initialize part of the collection
                        if (!newConversations.hasOwnProperty(msg.classification)) {
                            newConversations[msg.classification] = {};
                        }
                        if (!newConversations[msg.classification].hasOwnProperty(msg.conversationId.toString())) {
                            newConversations[msg.classification][msg.conversationId.toString()] = [];
                        }

                        newConversations[msg.classification][msg.conversationId.toString()].push(msg.id);
                    }

                    // Open only with new conversations
                    if (newConversations && Object.keys(newConversations).length) {
                        this.rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                            stateName: this.appSettings.ROUTE_NAMES.meevoMessenger,
                            stateParams: {
                                isHasPulse: msg.isInbound,
                                isAddToStart: true,
                                isNotNavigateToSate: true,
                                newConversations: newConversations,
                                classification: msg.classification,
                                newConversationsCount: function () {
                                    const getCount = (collection: Meevo.Plugins.MeevoMessenger.MeevoMessengerConversation) => {
                                        return _.values(collection).reduce((accumulator: number, currentValue) => {
                                            return accumulator + _.values(currentValue).length
                                        }, 0);
                                    }
                                    return this.newConversations && Object.keys(this.newConversations).length ? getCount(this.newConversations) : 0;
                                },
                                customTemplate: 'app/plugins/meevoMessenger/badge.html'
                            },
                        });
                    }
                    if (isActive) {
                        this.rootScope.$broadcast(Meevo.Components.Common.Messages.MEEVO_MESSENGER_PROCESS_INBOUND_MESSAGE, msg)
                    };
                });

            this.rootScope.$on(Meevo.Components.Common.Messages.MEEVO_MESSENGER_REDUCE_BADGE_NUMBER,
                (event: angular.IAngularEvent, { conversationId, classification }: { conversationId: string, classification: Meevo.Model.TMeevoMessengerClassification }) => {
                    const meevoMessengerContext = <IContext>this.state.get(this.appSettings.ROUTE_NAMES.meevoMessenger);
                    const newConversations: Meevo.Model.IMeevoMessengerNewConversations = meevoMessengerContext.params.newConversations;

                    delete meevoMessengerContext.params.newConversations[classification][conversationId.toString()];

                    if (!newConversations) meevoMessengerContext.params.isHasPulse = false;

                    let arrivalsConversations = newConversations[Meevo.Plugins.MeevoMessenger.MeevoMessengerClassificationAPI.ARRIVALS] && Object.keys(newConversations[Meevo.Plugins.MeevoMessenger.MeevoMessengerClassificationAPI.ARRIVALS]).length;
                    let textelConversations = newConversations[Meevo.Plugins.MeevoMessenger.MeevoMessengerClassificationAPI.TEXTEL] && Object.keys(newConversations[Meevo.Plugins.MeevoMessenger.MeevoMessengerClassificationAPI.TEXTEL]).length;
                    let clientAppConversations = newConversations[Meevo.Plugins.MeevoMessenger.MeevoMessengerClassificationAPI.MEGO] && Object.keys(newConversations[Meevo.Plugins.MeevoMessenger.MeevoMessengerClassificationAPI.MEGO]).length;
                    let twoWaySmsConversations = newConversations[Meevo.Plugins.MeevoMessenger.MeevoMessengerClassificationAPI.TWOWAYSMS] && Object.keys(newConversations[Meevo.Plugins.MeevoMessenger.MeevoMessengerClassificationAPI.TWOWAYSMS]).length;

                    meevoMessengerContext.params.isHasPulse = textelConversations || arrivalsConversations || clientAppConversations || twoWaySmsConversations;
                });

            this.rootScope.$on(Meevo.Components.Common.Messages.EXTERNAL_ORDERING_AUTH_CODE_OBTAINED, (event, msg) => {
                if (this.rootScope.popupAvedaLoginWindow) {
                    this.rootScope.popupAvedaLoginWindow.close();
                    this.rootScope.popupAvedaLoginWindow = null;
                }

                // obtain the token from code
                var data = JSON.parse(msg);
                var request = { code: data.code, state: data.state, inventoryApp: data.inventoryApp };
                this.dataService.customMethodData(`api/ExternalOrder/Token`, "POST", request);
            });

            this.rootScope.$on(Meevo.Components.Common.Messages.EXTERNAL_ORDERING_AUTH_OBTAINED, (event, data) => {
                let dataObj = data;
                if (typeof data === "string") {
                    dataObj = JSON.parse(data);
                }
                if (dataObj) {
                    // update the status that it is successful in obtaining the token
                    if (dataObj.externalInventoryAppEnum == 11045761/*aveda*/) {
                        // update the status that it is successful in obtaining the token
                        this.rootScope.$broadcast(Meevo.Components.Common.Messages.EXTERNAL_ORDERING_ACCESS_TOKEN_OBTAINED, dataObj);
                    }
                    else if (dataObj.externalInventoryAppEnum == 11045824/*SalonInteractive*/) {
                        const iframe = document.getElementById('salon-interactive') as HTMLIFrameElement;
                        iframe.contentWindow.postMessage({ type: 'si-token-state', tokenState: true, data: dataObj }, '*');
                    }
                }
            });

            //#region logout after reload
            if ($cookies.get(Meevo.Components.Common.REMOVE_THIS_COOKIE_AND_DO_LOGOUT_KEY) === '1') {
                // means user did refresh the page in kiosk mode
                // we have to make him logout

                dataService.getIdentity().then(identity => {
                    $cookies.remove(Meevo.Components.Common.REMOVE_THIS_COOKIE_AND_DO_LOGOUT_KEY);

                    dataService.logout().then(() => {
                        $window.onbeforeunload = () => null;
                        if (identity && identity.sessionTimeoutRedirectUrl) {
                            $window.location.href = identity.sessionTimeoutRedirectUrl;
                        }
                    });
                });

                return;
            }
            //#endregion logout after reload

            this.initShortCutGroup();
            this.shortCutsService.activateGroup(this.globalShortCutGroup);

            $mdComponentRegistry.when('left').then(() => {
                let sideContextMenu = this.sideContextMenu('left');
                this.scope.$watch(
                    () => {
                        this.blur = sideContextMenu.isOpen();
                    },
                    () => sideContextMenu.isOpen()
                );
            });


            $mdSidenav('Search', true)
                .then((instance) => {
                    instance.onClose(() => this.shortCutsService.deactivateGroup(this.searchMenuShortCutsGroup));
                });

            /**
             * Function to handle any controller initialization.
             * Here we pre-add a context for the 'home' state since that is
             * the default, non-removable context
             */
            var init = function (): void {
                //var home = <IContext>_.findWhere(controller.states, { name: 'home' });
                controller.addContext("home");
            };

            /**
             * Call init()
             */
            init();
        }

        private sessionReplayRecording = false;

        viewChanged(event, toState) {
            this.setDatadogView(event, toState);
        }

        setDatadogView(event, toState) {
            if (!this.$window['DatadogRumEnabled']) {
                return;
            }

            console.debug('setDatadogView', toState.name);
            this.$window.DD_RUM && this.$window.DD_RUM.startView(toState.name, toState.name);

            const datadogReplayTenantId = (this.$window["DatadogPremiumTenantId"] || '').split(',');
            const datadogReplayLocationId = (this.$window["DatadogPremiumLocationId"] || '').split(',');
            const datadogReplayUserId = (this.$window["DatadogPremiumUserId"] || '').split(',');
            let enableRecording = false;

            if (datadogReplayTenantId[0] != '' ||
                datadogReplayLocationId[0] != '' ||
                datadogReplayUserId[0] != ''
            ) {
                const identityCurrent = this.identityService.current();

                enableRecording = datadogReplayTenantId.some(tenantId =>
                    tenantId == '' ||
                    tenantId == identityCurrent.tenantId);

                if (enableRecording) {
                    enableRecording = datadogReplayLocationId.some(locationId =>
                        locationId == '' ||
                        locationId == identityCurrent.locationId);
                }

                if (enableRecording) {
                    enableRecording = datadogReplayUserId.some(userId =>
                        userId == '' ||
                        userId == identityCurrent.userId ||
                        userId == identityCurrent.userName ||
                        userId == identityCurrent.userAuthId ||
                        userId == identityCurrent.userAuthName);
                }
            }

            if (enableRecording) {
                if (!this.sessionReplayRecording) {
                    console.debug(toState.name, 'startSessionReplayRecording');
                    this.$window.DD_RUM.startSessionReplayRecording();
                    this.sessionReplayRecording = true;
                }
            } else {
                if (this.sessionReplayRecording) {
                    console.debug(toState.name, 'stopSessionReplayRecording');
                    this.$window.DD_RUM.stopSessionReplayRecording();
                    this.sessionReplayRecording = false;
                }
            }
        }

        /**
         * Opens the main "hero" menu
         */
        openMenu(): void {
            // Clear out submenu so that the submenu view is guaranteed to be rebuilt.  The view doesn't appear to get
            // rebuilt if you choose a menuitem, close the menu and the open and choose the same menu item.
            this.rootScope.$emit(Meevo.Components.Common.Messages.SUB_MENU_SHOW, []);


            if (!this.modalPromise) {

                //this.modalPromise = this.modal.show(options);
                //this.sideContextMenu('left').toggle();
                this.sideNavSafeToggle(this, 'left')
                    .then(() => this.menuService.activateMenuShortCutGroup());

            }
        }

        onSearchCloseMenu(): void {
            this.sideContextMenu('Search').close().then((o) => {
                this.rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_SEARCH_MENU_COMPLETE, null);
            });
        }

        onOpenSearchMenu(): void {
            this.sideContextMenu('Search').open().then((o) => {
                this.shortCutsService.activateGroup(this.searchMenuShortCutsGroup);
                this.rootScope.$broadcast(Meevo.Components.Common.Messages.OPEN_SEARCH_MENU_COMPLETE, null);
                this.meevoTracker.saveTrackingInfo(new Meevo.Model.TrackingItem(Meevo.Model.NounEnum.ClientFindSearch, Meevo.Model.VerbEnum.ClientFindButtonClicked, null));
            });
        }

        onCloseAiChat(): void {
            this.sideContextMenu('AiChat').close().then((o) => {
                this.rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_AICHAT_COMPLETE, null);
            });
        }

        onOpenAiChat(): void {
            this.sideContextMenu('AiChat').open().then((o) => {
                this.shortCutsService.activateGroup(this.searchMenuShortCutsGroup);
                this.rootScope.$broadcast(Meevo.Components.Common.Messages.OPEN_AICHAT_COMPLETE, null);
                this.aiChatMinimized = false;
                //this.meevoTracker.saveTrackingInfo(new Meevo.Model.TrackingItem(Meevo.Model.NounEnum.ClientFindSearch, Meevo.Model.VerbEnum.ClientFindButtonClicked, null));
            });
        }

        aiChatMinimized: boolean = false;

        openSecondMenu(menuItem: IMenuItem): void {
            this.currentMenuItem = menuItem;
            if (menuItem.stateName && (!menuItem.subMenuItems || menuItem.subMenuItems instanceof Array && menuItem.subMenuItems.length === 0)) {
                // if menu group has stateName but there is no any subMenuItems navigate to stateName on click
                this.rootScope.$broadcast(
                    Meevo.Components.Common.Messages.MENU_ITEM_SELECTED,
                    menuItem.stateName,
                    menuItem.stateParams || null
                );
            } else if (!this.modalPromise && this.isOpen) {
                this.isOpen = true;
                this.sideNavSafeToggle(this, 'leftSecond')
                    .then(() => {
                        this.menuService.generateSubMenuShortCutGroup(menuItem);
                        this.menuService.activateSubMenuShortCutGroup();
                    });
                //this.sideContextMenu('leftSecond').toggle();


                this.subMenuItems = menuItem.subMenuItems;
                this.rootScope.$emit(Meevo.Components.Common.Messages.SUB_MENU_SHOW, this.subMenuItems);

            } else {
                this.subMenuItems = menuItem.subMenuItems;
                this.rootScope.$emit(Meevo.Components.Common.Messages.SUB_MENU_SHOW, this.subMenuItems);

                this.sideNavSafeClose(this, 'leftSecond');
                this.sideNavSafeOpen(this, 'leftSecond')
                    .then(() => {
                        this.menuService.generateSubMenuShortCutGroup(menuItem);
                        this.menuService.activateSubMenuShortCutGroup();
                    });
                //this.sideContextMenu('leftSecond').close();
                //this.sideContextMenu('leftSecond').open();
            }
        }

        /**
         * Emits a message to apply the specified parmaters to a specified context
         * @param contextItem
         * @param params
         */
        private broadcastApplyParams(contextItem, params) {
            this.rootScope.$broadcast(Meevo.Components.Common.Messages.APPLY_PARAMS_TO_CONTEXT, contextItem, params);
        }

        /**
         * Navigates to a specified state.
         * 1. If the requested state is already the current state, we simply broadcast the parameters so the current state can process them
         * 2. If the requested state is not yet active, we call the router to go to the state ONLY passing the state name. We intentionally do not pass the parameters to the go() function
         * 2a. If parameters are present, we hold them locally in a ParmaterMetadata object so they can be broadcast after the state change is complete
         * 2b. We also populate the contextParams service's params property with the parameters so that they can be processed if the context is brand new
         * @param contextItem
         * @param params
         * @param isConvoOrigin
         */
        navigateToState(contextItem, params, isConvoOrigin = false) {
            if (this.state.current.name == contextItem.name) {
                if (!_.isEmpty(params)) {
                    this.broadcastApplyParams(contextItem, params);
                }
            } else {
                this.state.go(contextItem.name);

                this.contextParams.params = null;
                if (!_.isEmpty(params)) {
                    this.pendingParameters = new ParameterMetadata(contextItem, params);
                    this.contextParams.params = params;
                }
            }

            // If this is called as a result of a user interaction (i.e. not via the convo)
            // then we broadcast that the context item has changed so the convo can sync itself with
            // the newly selected context.
            if (!isConvoOrigin) {
                this.rootScope.$broadcast(Meevo.Components.Common.Messages.SYNCHRONIZE_CONVO, contextItem);
            }

            this.setAnalyticsTrackingUrl(contextItem.name);
        }

        /**
         * Adds a context to the collection of available contexts
         *
         * @param menuItem
         */
        addContext(stateName: string, params?: Object, isConvoOrigin: boolean = false) {

            let controller = this;
            var contextItem = <IContext>this.state.get(stateName);            
            if (params) {
                contextItem.params = params;
            }

            if (this.sessionKeepAliveContexts.indexOf(contextItem.name) > -1) {
                this.rootScope.$broadcast(Meevo.Components.Common.Messages.KEEP_SESSION_ALIVE, contextItem);
            }
            // currently not allowing more than one of the same context
            var existing = _.findWhere(this.contexts, { name: contextItem.name });
            if (!existing) {
                contextItem.navigate = function () {
                    const shortDescripion: string = controller.getShortDescription(
                        Meevo.Model.NounEnum.FeatureTab,
                        Meevo.Model.VerbEnum.Selected,
                        controller.filter<any>('meevoAutoCapitalization')(contextItem.auditName || contextItem.name)
                    );

                    controller.meevoTracker.saveTrackingInfo(new Meevo.Model.TrackingItem(
                        Meevo.Model.NounEnum.FeatureTab,
                        Meevo.Model.VerbEnum.Selected,
                        controller.filter<any>('meevoAutoCapitalization')(contextItem.name),
                        null,
                        shortDescripion
                    ));
                    controller.navigateToState(contextItem, null);
                }
                let that = this;

                let close

                if (!contextItem.close) {
                    contextItem.close = function () {
                        if (contextItem.warnUponClose) {
                            var state = <IContext>_.findWhere(controller.states, { name: contextItem.name });
                            that.rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT_WARNING, state);

                        } else {
                            controller.removeContext(contextItem);
                        }
                        that.rootScope.$broadcast(Meevo.Components.Common.Messages.ANALYTICS_CLEAR_SECTION, {}, contextItem.name);
                    }
                }
                if (params && (<any>params).isAddToStart) this.contexts.splice(1, 0, contextItem);
                else this.contexts.push(contextItem);

                this.refreshStickyContexts();
            }
            let isNotNavigate = params && (<any>params).isNotNavigateToSate;
            // go to the state
            if (!isNotNavigate) this.navigateToState(contextItem, params, isConvoOrigin);
        }

        /**
         * Refresh a collection of any contexts that are currently open and
         * are leveraging a 'sticky' state. This collection drives the set
         * of ui-view divs that are present for the states that retain their DOM.
         * When these contexts are added or removed, we want the div to be added
         * or removed as well.
         */
        refreshStickyContexts(): void {
            this.stickyContexts = _.where(this.contexts, { sticky: true });
        }

        /**
         * Removes a context from the list of available contexts.
         * Navigates to the default state after the context has been removed.
         *
         * There is an ability to move to existing context after current context is closed by specifying targetStateName.
         * If specified context doesn't exist, you will move to previous context.
         *
         * For moving to nonexistent context (create the context before), use two parameters in pair:
         * targetStateName - nonexistent context where you want to move
         * createContext - set it to true
         *
         * @param contextItem
         * @param targetStateName
         * @param createContext
         */
        removeContext(contextItem: IContext, targetStateName?: string, createContext?: boolean) {
            var contextName = contextItem.name;
            if (this.sessionKeepAliveContexts.indexOf(contextItem.name) > -1) {
                this.rootScope.$broadcast(Meevo.Components.Common.Messages.RESTART_SESSION_COUNTDOWN);
            }

            //Check if the context is being removed so we know if we need to navigate to a new state
            var active = this.state.includes(contextItem.name);

            if (contextItem.name === this.appSettings.ROUTE_NAMES.callCenter
                && !!this.identityService.current().asImpersonateLocationId) {
                this.contexts
                    .filter(context => !this.callCenterSafeContexts
                        .find(safeContext => safeContext === context.name))
                    .forEach(unsafeContext => this.removeContext(unsafeContext));

                targetStateName = this.appSettings.ROUTE_NAMES.home;
                active = true;
            }

            // find previous accessible context index
            var index = _.findIndex(this.contexts, (context: IContext) => context.name === contextName);
            let contexts = angular.copy(this.contexts).slice(-0, index);
            let previous = _.find(contexts.reverse(), c => this.securityService.hasSecurity(c.securityKey + this.securityParts.KEY_PART_READ));
            index = _.findIndex(this.contexts, (context: IContext) => context.name === previous.name);

            // remove the context from the collection
            this.contexts = _.reject(this.contexts, (context: IContext) => context.name === contextName);

            // passing context name state
            this.rootScope.$broadcast(Meevo.Components.Common.Messages.CONTEXT_HAS_CLOSED, contextName);

            // refresh the collection of sticky contexts which drives the
            // ui-view divs for these contexts which retain their DOM
            this.refreshStickyContexts();

            // navigate to the context that came before the one we are removing if the one being removed was the active context
            if (active) {
                var newContextItem: IContext = null;
                // If supplied, navigate to the specified targetStateName, otherwise this will navigate to $state-1
                if (targetStateName && targetStateName !== "") {
                    newContextItem = _.findWhere(this.contexts, { name: targetStateName });
                }
                // If callbackState is in the contextItem, navigate to the specified callbackState
                if (newContextItem == null && contextItem.params) {
                    if (contextItem.params.callbackState) {
                        newContextItem = _.findWhere(this.contexts, { name: contextItem.params.callbackState });
                    }
                    if (contextItem.params.callback) {
                        contextItem.params.callback(null);
                    }
                }
                // if we want to create a new context and navigate there
                if (newContextItem == null && createContext) {
                    this.addContext(targetStateName);
                    return;
                }
                // If no targetStateName and/or callbackState are specified, use the previous context
                if (newContextItem == null) {
                    newContextItem = this.contexts[index];
                }
                this.navigateToState(newContextItem, null);
            }
        }

        /**
         * Called when a menu item is selected
         */
        onMenuItemSelected(stateName: string, params: Object, isConvoOrigin: boolean = false): void {
            this.addContext(stateName, params, isConvoOrigin);
            this.sideNavSafeClose(this, 'leftSecond');
            this.sideNavSafeClose(this, 'left');

            //this.sideContextMenu('leftSecond').close();
            //this.sideContextMenu('left').close();

            //if (this.blur == true) {
            //  this.blur = false;
            //} else {
            //  this.blur = true;
            //}
        }

        onCloseMenu(): void {
            this.sideNavSafeClose(this, 'leftSecond');
            this.sideNavSafeClose(this, 'left');
            //this.sideContextMenu('leftSecond').close();
            //this.sideContextMenu('left').close();

            //if (this.blur == true) {
            //  this.blur = false;
            //} else {
            //  this.blur = true;
            //}
            this.modalPromise = null;
        }


        /* Workaround to 'safely' insure an instance of the sideNav is available
          before calling close on it.
          See: https://github.com/SebastianMetzger/angular-material-inbox/issues/1
          Also: http://luxiyalu.com/angular-material-no-instance-found-for-handle-left/
        */
        sideNavSafeClose(controller, instanceName): void {
            this.$mdComponentRegistry.when(instanceName).then((it) => {
                it.close();

                controller.blur = false;
            });
        }

        /* Workaround to 'safely' insure an instance of the sideNav is available
          before calling toggle on it.
          See: https://github.com/SebastianMetzger/angular-material-inbox/issues/1
          Also: http://luxiyalu.com/angular-material-no-instance-found-for-handle-left/
        */
        sideNavSafeToggle(controller, instanceName): ng.IPromise<void> {
            return this.$mdComponentRegistry.when(instanceName).then((it) => {
                it.toggle();

                if (controller.blur) {
                    controller.blur = false;
                } else {
                    controller.blur = true;
                }
            });
        }

        /* Workaround to 'safely' insure an instance of the sideNav is available
          before calling open on it.
          See: https://github.com/SebastianMetzger/angular-material-inbox/issues/1
          Also: http://luxiyalu.com/angular-material-no-instance-found-for-handle-left/
        */
        sideNavSafeOpen(controller, instanceName): ng.IPromise<void> {
            return this.$mdComponentRegistry.when(instanceName).then((it) => {
                it.open();

                controller.blur = true;
            });
        }

        private initShortCutGroup() {
            this.globalShortCutGroup = new ShortCutGroup([
                {
                    shortCutName: 'GLOBAL_MENU',
                    callback: () => {
                        this.openMenu();
                    }
                },
                {
                    shortCutName: 'GLOBAL_FIND',
                    callback: () => {
                        this.onOpenSearchMenu();
                    }
                },
                {
                    shortCutName: 'GLOBAL_HELP',
                    callback: () => {
                        this.menuService.openMeevoHelp();
                    }
                },
                {
                    shortCutName: 'GLOBAL_LOCKOUT',
                    callback: () => {
                        this.rootScope.$broadcast(Meevo.Components.Common.Messages.SESSION_TIMEOUT_HANDLER, Meevo.Model.SessionState.Lockout, 'ShortCut');
                    }
                },
                {
                    shortCutName: 'GLOBAL_LOCATION',
                    callback: () => {
                        let options = {
                            templateUrl: 'app/components/locationPicker/locationPicker.html',
                            controller: 'meevo.components.locationPicker.LocationPickerController',
                            controllerAs: 'locationPicker',
                            bindToController: true,
                            locals: { isRelockAvailable: false }
                        };
                        if (!this.identityService.current().isSingleLocation) {
                            this.modalService.showCustom(options);
                        }
                    }
                }
            ], { groupLevel: Components.ShortCuts.GroupLevels.Global, noun: Meevo.Model.NounEnum.GeneralKeyboardShortcut });
        }

        private getShortDescription(nounEnum: Meevo.Model.NounEnum, verbEnum: Meevo.Model.VerbEnum, pluginName?: string) {
            const nounStr: string = Meevo.Model.NounEnum[nounEnum].split(/(?=[A-Z])/).join(' ');
            const verbStr: string = Meevo.Model.VerbEnum[verbEnum];
            const preparedName = this.filter<any>('meevoAutoCapitalization')(pluginName);
            return `${nounStr} ${verbStr} ${preparedName}`;
        }

        private handleCallCenterEmulation(effectiveCallCenterId: number): void {

            /**
             * Call Center emulation was in effect when the app was loaded. Need to get logged-in location security
             * before we can proceed to patch the emulated data in front end
             */
            if (Model.Guard.isSomething(effectiveCallCenterId) && effectiveCallCenterId > 0) {

                this.dataService.customMethodData(`${this.appSettings.API_ROOT}/CallCenter/Emulate`, 'POST', { newLocationId: undefined })
                    .then((response: angular.IHttpPromiseCallbackArg<Components.Common.IEmulateResponse>) => {

                        if (Meevo.Model.Guard.isSomething(response.data.security)) {
                            this.securityService.emulateLocationSecurity(response.data.security);
                            this.rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                                stateName: this.appSettings.ROUTE_NAMES.callCenter
                            });
                        }
                    });
            }

            // Cleanup leftover local storage if user closed browser without ending emulation
            if (this.$window.localStorage.getItem(Components.Common.Constants.CALL_CENTER_EMULATION_STORAGE)
                && !this.identityService.isEmulating) {

                this.$window.localStorage.removeItem(Components.Common.Constants.CALL_CENTER_EMULATION_STORAGE);
            }

            let emulationEventHandler = (event) => {
                if (event.storageArea !== localStorage
                    || event.key !== Components.Common.Constants.CALL_CENTER_EMULATION_STORAGE) {
                    return;
                }

                const storageData = JSON.parse(event.newValue);
                const identityData = this.identityService.emulationData;

                if ((!storageData && this.identityService.isEmulating)
                    || storageData.effectiveCallCenterId !== identityData.effectiveCallCenterId
                    || storageData.asImpersonateLocationId !== identityData.asImpersonateLocationId
                    || storageData.loggedInLocation !== identityData.loggedInLocation) {

                    let options = {
                        templateUrl: "app/components/modal/modal.template.html",
                        controller: "meevo.plugins.callCenter.CallCenterSyncModalController",
                        controllerAs: "vm",
                        bindToController: true,
                        locals: { isRelockAvailable: false }
                    };

                    this.modalService.showCustom(options);
                }
            }

            this.$window.removeEventListener('storage', emulationEventHandler);
            this.$window.addEventListener('storage', emulationEventHandler);
        }

        private setAnalyticsTrackingUrl(name: string) {
            const pendo = window['pendo'];
            if (!pendo || !pendo.location) return;

            const url = `${window.location.origin}/${name}`;
            pendo.location.setUrl(url);
            console.log(`PENDO: ${url}`);
            this.rootScope.$broadcast(Components.Common.Messages.ANALYTICS_TRACK_CONTROLLER, {}, name);
        }

        private GoToMeevoAcademyCourseURL() {
            var academyCourseUrl = sessionStorage.getItem('mil:academy:courseUrl');
            if (academyCourseUrl) {
                this.dataService.customMethodData(this.appSettings.API_ROOT + '/' + 'MeevoStore/CommunityLink', 'GET', null, { 'LinkType': LinkType.MillenniumAcademy, 'academyCourseUrl': academyCourseUrl }).then(data => {
                    sessionStorage.removeItem('mil:academy:courseUrl');
                    if (data && data.data && data.data.errorMessage) {
                        this.modalService.alert(data.data.errorMessage);
                    } else if (data && data.data && data.data.link) {
                        this.$window.open(data.data.link, '_blank');
                    } else {
                        this.$window.open('https://speak.millenniumsi.com/s/education/', '_blank');
                    }
                });
            }
        }
    }


    angular.module('meevo')
        .controller('MainCtrl', MainCtrl);
}
